module.exports = __webpack_public_path__ + "img/hotelFamily-8.51addb28.jpg";